export const contact = {
  name: "Contact |||| Contacts",
  fields: {
    uuid: "Contact UUID",
    name: "Name",
    email: "Email",
    phone: "Phone",
    phoneNumber: "Phone Number",
    avatarUrl: "Avatar",
    lastActivityAt: "Last activity",
    metadata: "Metadata",
    createdAt: "Created at",
    updatedAt: "Updated at",
  },
  tabs: {
    details: "Details",
    identities: "Identities",
    conversations: "Conversations",
  },
  empty: {
    title: "No contacts",
    subtitle: "There are no contacts to display yet.",
  },
  noInfo: "No contact information",
  unknown: "Unknown",
  unknownContact: "Unknown Contact",
  merged: "Merged",
  lastActivity: "Last activity",
  details: "Contact details",
  phone: "Phone",
  email: "Email",
  channel: "Channel",
  customFields: "Custom fields",
  neverActive: "Never active",
  create: {
    title: "Create New Contact",
  },
  edit: {
    title: "Edit Contact: %{name}",
  },
  filters: {
    searchName: "Search name",
    searchEmail: "Search email",
  },
  conversations: {
    empty: "No conversations found for this contact.",
    conversation: "Conversation",
  },
};

export const contactIdentity = {
  name: "Identity |||| Identities",
  fields: {
    externalId: "External ID",
    name: "Name",
    channelType: "Channel Type",
    telegramUserId: "Telegram User ID",
    telegramGroupId: "Telegram Group ID",
    group: "Group",
  },
  externalIdLabels: {
    zapy: "WhatsApp Number",
    telegram: "Telegram ID",
    telegram_group: "Telegram Group ID",
    email: "Email Address",
    default: "External ID",
  },
  empty: "No identities linked to this contact.",
  verified: "Verified",
  group: "Group",
  individual: "Individual",
};
